module.exports = {"371623001":"棣丰街道","371623002":"海丰街道","371623101":"水湾镇","371623102":"碣石山镇","371623103":"小泊头镇","371623104":"埕口镇","371623105":"马山子镇","371623106":"车王镇","371623107":"柳堡镇","371623108":"佘家镇","371623109":"信阳镇","371623110":"西小王镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371623.json
// module id = 1616
// module chunks = 0